import { render, staticRenderFns } from "./CustomerBalanceDownloadReport.vue?vue&type=template&id=81bdee5c&"
import script from "./CustomerBalanceDownloadReport.vue?vue&type=script&lang=js&"
export * from "./CustomerBalanceDownloadReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports